import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-numero_svg__a"
        d="M15.6 13.3h2.7l-.4 2h-2.7l-.7 3.7h-2.3l.7-3.7H10L9.3 19H7l.7-3.7H5l.4-2h2.7l.5-2.6H5.9l.4-2H9L9.7 5H12l-.7 3.7h2.9l.7-3.7h2.3l-.7 3.7h2.7l-.4 2h-2.7l-.5 2.6zm-2.3 0l.5-2.6h-2.9l-.5 2.6h2.9z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-numero_svg__a"
    />
  </svg>
);
